import Swiper from "swiper/bundle";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export default {
    name: "slideshow",
    _selector: ".swiper",
    init() {
        const swipers = document.querySelectorAll(this._selector);

        if (swipers) {
            for (let i = 0; i < swipers.length; i++) {
                let swiperType = swipers[i].getAttribute("data-swiper");
                let slides = swipers[i].getAttribute("data-slides");
  
                if (swiperType == 'gallery') {
                    swipers[i].classList.add("swiper-container-" + i);
                    this.run(".swiper-container-" + i, this.setGalleryConfig());
                } else if(swiperType == 'banner') {
                    swipers[i].classList.add("swiper-container-" + i);
                    this.run(".swiper-container-" + i, this.setBannerConfig(slides)); 
                } else if(swiperType == 'free-mode') {
                    swipers[i].classList.add("swiper-container-" + i);
                    this.run(".swiper-container-" + i, this.setFreeModeConfig(slides));
                } else {
                    swipers[i].classList.add("swiper-container-" + i);
                    this.run(".swiper-container-" + i, this.setSwipersConfig(slides));
                } 
               
            }
        }
    },

    setGalleryConfig() {
        return {
            loop: true,
            spaceBetween: 30,
            slidesPerView: 1,
            pagination: {
                el: ".swiper-pagination",
                type: "fraction",
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        }
    },

    setSwipersConfig(slides) {
        slides = slides <= 3 ? slides : 3;

        return {
            loop: true,
            spaceBetween: 30,
            slidesPerView: 1.2,
            // centeredSlides: true,
            breakpoints: {
                768: {
                    loop: false,
                    slidesPerView: 2,
                },
                1024: {
                    loop: false,
                    slidesPerView: slides,
                },
            },
        }
    },

    setFreeModeConfig(slides) {
        slides = slides <= 3 ? slides : 3;

        return {
            loop: false,
            slidesPerView: 'auto',
            freeMode: true,
            spaceBetween: 20,

            // centeredSlides: true,
            breakpoints: {
                768: {

                }
            },
        }
    },

    setBannerConfig() {
        return {
            autoplay: {
                delay: 5000,
            },
            slidesPerView: 1,
            pagination: {
                el: ".swiper-pagination",
                type: 'bullets',
            },
        }
    },

    run(selector, config) {
        
        let swiper = new Swiper(selector, config);
    },
};
